module.exports = __webpack_public_path__ + "img/info-circle-fill.e2328a16.svg";